import { Controller } from 'stimulus';

class CustomJourneyController extends Controller {
  connect() {
    this.itemsCount = 0;

    this.updateItemsCount();
    this.outputAmountRegions();
    this.outputAmountOfPersons();
  }

  addItem({ currentTarget }) {
    if (currentTarget.classList.contains('is-selected')) return;

    const id = parseInt(currentTarget.dataset.id, 10);
    const amountOfPersons = this.getAmountOfPersons();
    const amountOfAdults = this.getAmountOfAdults();
    const amountOfChildren = this.getAmountOfChildren();
    const amountOfBabies = this.getAmountOfBabies();
    const amountOfRooms = this.getAmountOfRooms();
    const dateOfArrival = this.getDateOfArrival();

    $.ajax({
      url: window.app.api.journeyCartItem.store,
      method: 'POST',
      data: {
        id,
        amount_of_persons: amountOfPersons,
        amount_of_adults: amountOfAdults,
        amount_of_children: amountOfChildren,
        amount_of_babies: amountOfBabies,
        amount_of_rooms: amountOfRooms,
        date_of_arrival: dateOfArrival,
      },
      success: (res) => {
        const { item } = res;

        currentTarget.querySelector('.btn__text').innerText = window.app.i18n.addedToJourney;
        currentTarget.classList.add('is-selected');

        $(this.sliderTarget).slick(
          'slickAdd',
          CustomJourneyController.renderItem(item),
          this.slideTargets.length,
          true,
        );

        this.updateItemsCount();
        this.openOverlay();
      },
    });
  }

  removeItem({ currentTarget }) {
    const { id, journeyCartItemId } = currentTarget.dataset;
    const slide = currentTarget.closest('[data-target="custom-journey.slide"]');
    const slideIndex = parseInt(slide.dataset.slickIndex, 10);

    $.ajax({
      url: window.app.api.journeyCartItem.destroy,
      method: 'POST',
      data: {
        _method: 'DELETE',
        journey_cart_item_id: journeyCartItemId,
      },
      success: () => {
        $(this.sliderTarget).slick('slickRemove', slideIndex).slick('refresh');

        this.addTargets.forEach((addButton) => {
          if (parseInt(addButton.dataset.id, 10) === parseInt(id, 10)) {
            addButton.querySelector('.btn__text').innerText = window.app.i18n.addToJourney;
            addButton.classList.remove('is-selected');
          }
        });

        this.updateItemsCount();

        if (this.itemsCount === 0) {
          this.hideOverlay();
        }
      },
    });
  }

  updateItemsCount() {
    if (!this.hasCountTarget) return;

    this.itemsCount = this.slideTargets.length;

    const text = this.itemsCount === 1
      ? this.countTarget.dataset.singularText
      : this.countTarget.dataset.pluralText;

    this.countTarget.innerText = `${this.itemsCount} ${text}`;
    this.headerCountTarget.innerText = this.itemsCount;

    this.updateContinueButtonState();
  }

  updateContinueButtonState() {
    this.continueTarget.addEventListener('click', (e) => {
      if (!this.itemsCount) {
        e.preventDefault();
      }
    });

    this.continueTarget.classList.toggle('disabled', !this.itemsCount);
  }

  getAmountOfPersons() {
    if (!this.hasAmountOfPersonsTarget) return 0;

    return this.amountOfPersonsTarget.value;
  }

  getAmountOfAdults() {
    if (!this.hasAmountOfAdultsTarget) return 0;

    return parseInt(this.amountOfAdultsTarget.value, 10);
  }

  getAmountOfChildren() {
    if (!this.hasAmountOfChildrenTarget) return 0;

    return parseInt(this.amountOfChildrenTarget.value, 10);
  }

  getAmountOfBabies() {
    if (!this.hasAmountOfBabiesTarget) return 0;

    return parseInt(this.amountOfBabiesTarget.value, 10);
  }

  getAmountOfRooms() {
    if (!this.hasAmountOfRoomsTarget) return 0;

    return parseInt(this.amountOfRoomsTarget.value, 10);
  }

  getDateOfArrival() {
    if (!this.hasDateOfArrivalTarget) return 0;

    return this.dateOfArrivalTarget.value;
  }

  openOverlay() {
    this.overlayTarget.classList.add('is-open');
  }

  hideOverlay() {
    this.overlayTarget.classList.remove('is-open');
  }

  toggleOverlay() {
    this.overlayTarget.classList.toggle('is-open');
  }

  onDateChange(e) {
    const collapse = e.target.closest('.collapse');

    if (collapse) {
      $(collapse).collapse('hide');
    }

    if (this.hasDateOfArrivalOutputTarget) {
      this.dateOfArrivalOutputTarget.innerText = e.target.value;
    }
  }

  onResetDate(e) {
    const collapse = e.target.closest('.collapse');

    if (collapse) {
      $(collapse).collapse('hide');
    }

    if (this.hasDateOfArrivalOutputTarget) {
      this.dateOfArrivalOutputTarget.innerText = 'Selecteer een datum';
    }

    if (this.hasDateOfArrivalTarget) {
      this.dateOfArrivalTarget.value = '';
    }
  }

  outputAmountOfPersons() {
    if (!this.hasAmountOfPersonsOutputTarget) return;

    const adults = this.getAmountOfAdults();
    const children = this.getAmountOfChildren();
    const babies = this.getAmountOfBabies();
    const amountOfPersons = adults + children + babies;
    const suffix = amountOfPersons === 1 ? 'persoon' : 'personen';

    if (amountOfPersons === 1) {
      this.amountOfPersonsOutputTarget.innerText = 'Gasten toevoegen';
    } else {
      this.amountOfPersonsOutputTarget.innerText = `${amountOfPersons} ${suffix}`;
    }
  }

  outputAmountRegions() {
    if (!this.hasAmountOfRegionsOutputTarget) return;

    const amountOfRegions = this.regionTargets.filter((region) => region.checked).length ?? 0;
    const suffix = amountOfRegions === 1 ? 'regio geselecteerd' : 'regios geselecteerd';

    if (amountOfRegions === 0) {
      if (this.hasNoRegionTarget) {
        this.noRegionTarget.checked = true;
      }

      this.amountOfRegionsOutputTarget.innerText = 'Selecteer een regio';
    } else {
      if (this.hasNoRegionTarget) {
        this.noRegionTarget.checked = false;
      }

      this.amountOfRegionsOutputTarget.innerText = `${amountOfRegions} ${suffix}`;
    }
  }

  onNoRegionChange() {
    this.regionTargets.forEach((region) => {
      region.checked = false;
    });

    this.outputAmountRegions();
  }

  static renderItem(item) {
    return `
      <div class="custom-journey-items__slide" data-target="custom-journey.slide">
        <div class="custom-journey-items__item">
          <button
            type="button"
            class="custom-journey-items__remove btn--reset"
            data-id="${item.id}"
            data-action="click->custom-journey#removeItem"
            data-journey-cart-item-id="${item.journey_cart_item_id}"
          >
            ${CustomJourneyController.getIcon('trash')}
          </button>

          <div class="position-relative overflow-hidden ratio--3-2">
            <img
              data-src="${item.image}"
              alt=""
              class="img-fit absolute-center lazyload"
              loading="lazy"
            >
          </div>

          <div class="font-size-xxs mt-2">
            ${item.title}
          </div>
        </div>
      </div>
    `;
  }

  static getIcon(name) {
    return `<svg class="icon icon-${name}" aria-hidden="true"><use xlink:href="#icon-${name}"></use></svg>`;
  }
}

CustomJourneyController.targets = [
  'add',
  'overlay',
  'count',
  'items',
  'slider',
  'slide',
  'region',
  'continue',
  'headerCount',
  'amountOfPersons',
  'amountOfAdults',
  'amountOfChildren',
  'amountOfRooms',
  'amountOfBabies',
  'dateOfArrival',
  'noRegion',
  'dateOfArrivalOutput',
  'amountOfPersonsOutput',
  'amountOfRegionsOutput',
];

export default CustomJourneyController;
